import React from 'react'
import { Routes, Route } from 'react-router-dom'

import { RegistrationContainer } from '../../components/RegistrationContainer'
import { PaginationProvider } from '../../contexts/PaginationContext'
import { useBreadcrumb } from '../../hooks/useBreadcrumb'

import { OrdersTable, OrderForm } from './components'

export const Orders: React.FC = () => {
  const breadcrumb = useBreadcrumb({
    pedidos: 'Pedidos',
    inclusao: 'Inclusão',
    edicao: 'Edição'
  })

  return (
    <RegistrationContainer breadcrumbItems={breadcrumb}>
      <PaginationProvider orderBy="order.code" order="DESC">
        <Routes>
          <Route path="/" element={<OrdersTable />} />
          <Route path="/inclusao" element={<OrderForm />} />
          <Route path="/edicao" element={<OrderForm />} />
        </Routes>
      </PaginationProvider>
    </RegistrationContainer>
  )
}
